import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { useSelect } from 'downshift'

export default function Select({
  label,
  items,
  renderItemLabel = item => item.value,
  renderSelectedItemLabel,
  getItemKey,
  value,
  style,
  onChange = () => {},
  icon
}) {
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    selectItem
  } = useSelect({
    items,
    onSelectedItemChange: ({ selectedItem }) => onChange(selectedItem)
  })

  useEffect(() => {
    selectItem(value)
  }, [value])

  return (
    <div
      class="relative border border-grey-light invalid:border-red-50 mt-3"
      style={style}
    >
      {icon}
      <label {...getLabelProps({ className: 'sr-only' })}>{label}</label>

      <button
        data-no-focus-visible
        type="button"
        {...getToggleButtonProps({
          className:
            'select-toggle appearance-none block relative z-10 w-full bg-white border-0 text-current py-0 pl-11 pr-9 text-left outline-none focus:outline-none focus:line-bottom expanded:line-bottom',
          style: { height: 65 }
        })}
      >
        {typeof selectedItem !== 'undefined' && selectedItem !== null
          ? renderSelectedItemLabel
            ? renderSelectedItemLabel(selectedItem)
            : renderItemLabel(selectedItem)
          : label}
      </button>

      <ul
        {...getMenuProps({
          className:
            'list-reset w-full table pb-5 pt-4 absolute pin-l pin-r pin-t -mx-px bg-white shadow max-h-1/2-screen overflow-auto' +
            (isOpen ? '' : ' hidden'),
          style: { marginTop: -1, paddingTop: 79 }
        })}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              class="instant-search-result instant-search-result-listbox relative flex flex-wrap sm:table-row text-grey-dark hover:text-black transition-color no-underline sm:border-b border-transparent cursor-pointer before:none"
              style={highlightedIndex === index ? { color: 'black' } : {}}
              key={getItemKey(item)}
              {...getItemProps({ item, index })}
            >
              {renderItemLabel(item)}
            </li>
          ))}
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/js/widget/Select.js